const comuni = {
    firestorePath: 'comuni',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'comuni',
    statePropName: 'data',
    namespaced: true, // automatically added
  
    // this object is your store module (will be added as '/myModule')
    // you can also add state/getters/mutations/actions
    state: {},
    getters: {
      asarray(){
        var reformattedArray = this.data.map(obj =>{ 
          var rObj = {};
          rObj[obj.Codice] = obj.value;
          return rObj;
       });
       return reformattedArray
      }
    },
    mutations: {},
    actions: {},
  }
  
  export default comuni